export default __webpack_public_path__ + "static/media/tpa-saml.ecfb9574.png";